<div class="base-container">
  @let egpDataValue = egpData();
  <h1 class="mat-h1">{{ 'PRODUCT.VERIFICATION.TITLE' | translate }}</h1>
  @if (showMini()) {
    <p>(Diese Seite ist nicht für kleine Bildschirme optimiert)</p>
  }
  @let egpAreasValue = egpAreas();
  @let riskBoxValuesValue = riskBoxValues();
  @if (egpAreasValue.length === 0 && !loading()) {
    <div style="height: 500px; width: 300px; margin: auto">
      <h3>
        Ab dem 2. November 2021 können Sie in diesem Bereich die
        Einsatzgebietsprognosen bewerten.
      </h3>
    </div>
  }

  <div class="flex-flow-wrapper">
    @if (egpAreasValue.length > 0) {
      <mat-card appearance="outlined" class="verification-card">
        <mat-card-header>
          <h1 class="mat-h1">{{ selectedArea().name }}</h1>
          @if (riskBoxValuesValue) {
            <h3 class="mat-h3">
              {{
                egpDataValue['textObject']['prescribeAt']
                  | datex
                    : 'DD.MM.YYYY HH:mm'
                    : undefined
                    : languageService.langSignal()
              }}
            </h3>
          }
        </mat-card-header>

        @if (riskBoxValuesValue) {
          <table class="cards-table" width="100%">
            <tr>
              <th width="49%">
                <img
                  src="/assets/brand/wm_30x30.png"
                  height="20"
                  align="left" />
                &nbsp; Prognose der Wettermanufaktur
              </th>
              <th width="49%">Ihre Beobachtung und Einschätzung</th>
              <th width="10">Übereinstimmung</th>
            </tr>
            <mat-divider></mat-divider>
            @for (
              quadrant of ['EIS', 'SCHNEE', 'NAESSE', 'REIF'];
              track $index
            ) {
              <tr>
                <td
                  class="glaette-header"
                  [ngStyle]="{ color: colors[quadrant] }">
                  {{ 'PRODUCT.EGP.RISKBOX.' + quadrant | translate }}
                </td>
                <td
                  colspan="2"
                  class="glaette-header"
                  [ngStyle]="{ color: colors[quadrant] }">
                  {{ 'PRODUCT.EGP.RISKBOX.' + quadrant | translate }}
                </td>
              </tr>
              <tr>
                @let starsEgpValue = starsEgp();
                @let starsVerificationValue = starsVerification();
                <td>
                  <app-star-rating
                    [rating]="starsEgpValue[quadrant]"
                    [starCount]="4"
                    [color]="colors[quadrant]"
                    [disableInput]="true">
                  </app-star-rating>
                  <p>
                    {{
                      'PRODUCT.EGP.LEGENDE.' + values[starsEgpValue[quadrant]]
                        | translate
                    }}
                  </p>
                </td>
                <td>
                  <app-star-rating
                    [rating]="starsVerificationValue[quadrant]"
                    [starCount]="4"
                    [color]="colors[quadrant]"
                    [disableInput]="false"
                    [clearButton]="true"
                    (ratingUpdated)="onRatingChanged(quadrant, $event)">
                  </app-star-rating>
                  <p>
                    {{
                      'PRODUCT.EGP.LEGENDE.' +
                        values[starsVerificationValue[quadrant]] | translate
                    }}
                  </p>
                </td>
                <td
                  [ngStyle]="{
                    color:
                      quadrant
                      | diffColor: starsEgpValue : starsVerificationValue,
                    fontSize: 'large',
                  }">
                  @let icon =
                    starsEgpValue[quadrant] === starsVerificationValue[quadrant]
                      ? 'check_circle'
                      : starsEgpValue[quadrant] <
                          starsVerificationValue[quadrant]
                        ? 'add_circle'
                        : 'remove_circle';
                  @let tooltip =
                    starsEgpValue[quadrant] === starsVerificationValue[quadrant]
                      ? 'EQUAL'
                      : starsEgpValue[quadrant] <
                          starsVerificationValue[quadrant]
                        ? 'MORE'
                        : 'LESS';
                  <mat-icon
                    matTooltip="{{
                      'PRODUCT.VERIFICATION.COMPARE.' + tooltip | translate
                    }}">
                    {{ icon }}
                  </mat-icon>
                </td>
              </tr>
              <mat-divider></mat-divider>
            }
          </table>
          &nbsp;
          <p align="center">
            <button mat-raised-button (click)="onReset()">Zurücksetzen</button>
            &nbsp;
            <button mat-raised-button (click)="onSave()" color="primary">
              Speichern
            </button>
          </p>
        } @else {
          {{ 'PRODUCT.EGP.noEGP' | translate }}
        }

        <mat-divider></mat-divider>
        <small>
          Hier können Sie den jeweils letzten 12 Uhr-Bericht verifizieren. In
          der linken Tabellenspalte sehen Sie die Vorhersage der
          Wettermanufaktur. In der rechten Spalte können Sie die von Ihnen
          beobachtete Glättestufe auswählen:
          <table>
            <tr>
              <td>
                <i class="fas fa-times" style="color: #9e9e9e"></i>
              </td>
              <td>
                {{ 'PRODUCT.EGP.LEGENDE.delete' | translate }}
              </td>
            </tr>
            @for (i of [0, 1, 2, 3, 4]; track $index) {
              <tr>
                <td>
                  <app-star-rating
                    [rating]="i"
                    [starCount]="4"
                    [color]="'#9e9e9e'"
                    [disableInput]="true">
                  </app-star-rating>
                </td>
                <td>
                  {{ gSomething[i] }}
                  {{ 'PRODUCT.EGP.LEGENDE.' + values[i] | translate }}
                </td>
              </tr>
            }
          </table>
        </small>
      </mat-card>
    }

    @if (egpAreasValue.length > 0) {
      <mat-card appearance="outlined" class="egp-card" #egpCard>
        @if (riskBoxValuesValue) {
          <div [attr.id]="'svg'"></div>
          <app-riskbox
            [riskBoxdata]="egpDataValue['matrices'][0]"
            [mini]="showMini()"
            [svgid]="'svg'"
            [season]="egpSeason.WINTER"></app-riskbox>
          @for (text of texts()[0]; track $index) {
            <p>{{ text }}</p>
          }
        }
      </mat-card>
    }
  </div>
</div>
